module.exports = __webpack_public_path__ + "static/media/calender-icon.69d9e95f.svg";